import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutWorker } from 'ducks/auth/actions';
import { user as userType } from 'api/users/types';
import logo from 'assets/images/im_logo2.png';
import { Button } from 'components/ui';
import logo2 from 'assets/images/logo2.svg';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({})
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      next: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string
      })
    })
  }).isRequired,
  history: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  user: userType,
};

class Logout extends React.Component {

  componentDidMount() {
    const { user, history, logout } = this.props;
    if(user) {
      logout();
    } else {
      history.replace('/login');
    }
  }

  render() {

    return (
      <div className="body login-page-wrapper">
        <div className="image-container">
          <div className="im-logo-container">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="form-container">
          <div className="form-container-inner">
            <div className="form-heading nomargin">
              <h3>
                Wylogowano
              </h3>
              <h5>Innovative thinking, global perspective</h5>
            </div>
            <Button to="/login" type="link" label="Zaloguj się ponownie" />
          </div>
          <div className="copyrights">
            <a href="https://kivy.pl/" >
              <span className="copyrights-text">Created by</span>
              <span className="kivy-logo"><img src={logo2} alt=""/></span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

const mapDispatch = {
  logout: logoutWorker
};

Logout.propTypes = propTypes;
const enhance = compose(connect(mapState, mapDispatch));

export default enhance(Logout);


// WEBPACK FOOTER //
// ./src/pages/logout/Logout.jsx